<template>
  <div>
    <div class="nav">
      <h2>授权管理</h2>
      <div>
        <img src="../../assets/img/shopify.jpg" alt />
        <h2>官方合作伙伴</h2>
      </div>
    </div>
    <div class="content">
        <el-alert v-show="isShowAlert" :title="this.isShow?'授权成功，请选择需要的操作':'授权失败，请选择需要的操作'" :closable="false" center :type="this.isShow?'success':'error'" show-icon></el-alert>
      <div class="return">
        <h2 v-show="this.isShow" style="color:#999">{{ time }}秒后自动返回店铺</h2>
        <h3>
          <span @click="enterHome">
            <i class="el-icon-s-home"></i>返回店铺
          </span>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import {  returnShopify } from "../../service"
export default {
    data(){
      return {
        isShow:false,
        isShowAlert:false,
        time:5,
      }
    },
    created(){
      this.Shopify();
    },
    methods:{
        enterHome(){
            this.$router.push({
                path:"/stores"
            })
        },
        Shopify(){
          let params = window.location.search.slice(1,window.location.search.length);
          returnShopify(params).then(res=>{
            if( res.data.code === 0 ){
              this.isShow = true;
              this.timeout();
            }else{
              this.isShow = false;
            }
            this.isShowAlert = true;
          })
        },
        timeout(){
          setInterval(()=>{
            this.time--;
            if(this.time<= 0){
              this.$router.push({
                path:"/stores"
            })
              return;
            }
          },1000)
        }
    }
};
</script>

<style lang="less" scoped>
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  border: 1px solid #e6e6e8;
  box-shadow: 0px 2px 6px #e6e6e8;
  > h2 {
    font-size: 22px;
    color: #77787c;
  }
  > div {
    display: flex;
    align-items: center;
    > img {
      width: 120px;
      height: 70px;
      margin-right: 10px;
    }
    > h2 {
      font-size: 22px;
      color: #77787c;
    }
  }
}
.content {
  width: 500px;
  margin: 0 auto;
  margin-top: 200px;
  > .return {
    text-align: center;
    min-height: 60px;
    line-height: 60px;
    > h3 {
      font-size: 20px;
      color: #4688c5;
      > span {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>